export default {
  SET_KEYCLOAK: 'SET_KEYCLOAK',
};
